import { render, staticRenderFns } from "./SecondCategoryList.vue?vue&type=template&id=3aaa1548&scoped=true"
import script from "./SecondCategoryList.vue?vue&type=script&lang=js"
export * from "./SecondCategoryList.vue?vue&type=script&lang=js"
import style0 from "./SecondCategoryList.vue?vue&type=style&index=0&id=3aaa1548&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaa1548",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aaa1548')) {
      api.createRecord('3aaa1548', component.options)
    } else {
      api.reload('3aaa1548', component.options)
    }
    module.hot.accept("./SecondCategoryList.vue?vue&type=template&id=3aaa1548&scoped=true", function () {
      api.rerender('3aaa1548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/dishGroupManage/SecondCategoryList.vue"
export default component.exports